import { combineReducers } from "redux";
import { reducer as editor } from 'app/pages/DiscountEditor/modules/Editor';
import { reducer as discountDates } from 'app/pages/DiscountEditor/modules/DiscountDates';
import { reducer as productSelection } from 'app/pages/DiscountEditor/modules/ProductSelection';
import { reducer as basicInfo } from 'app/pages/DiscountEditor/modules/BasicInfo';
import { reducer as agentSelection } from 'app/pages/DiscountEditor/modules/Agent';
import { reducer as countrySelection } from 'app/pages/DiscountEditor/modules/CountrySelection';
import { reducer as discountActions } from 'app/pages/DiscountEditor/modules/DiscountActions';
import { reducer as additionalCriteria } from 'app/pages/DiscountEditor/modules/AdditionalCriteria';
import { reducer as refData } from 'app/pages/DiscountEditor/modules/RefData'
import  divisions from "app/pages/DiscountEditor/modules/Divisions/reducer";

export const reducers = {
    editor,
    refData,
    basicInfo,
    discountDates,
    productSelection,
    agentSelection,
    countrySelection,
    discountActions, 
    additionalCriteria,
    divisions,
};

